<template>
  <b-card header="Order">
    <section v-if="loading" class="card-loader">
      <i class="fas fa-spinner fa-spin fa-3x"></i>
    </section>
    <section>
    <b-row class="mb-1">
      <b-col>
        <b-form-input 
          v-model="ui.order_id"
          type="text"
          placeholder="Order ID Lookup"
        />
      </b-col>
      <b-col>
        <b-button
          variant="success"
          block
          @click="$emit('fetch-order')"
        >
        Get This Order
        </b-button>
      </b-col>
      <b-col>
        <b-button
          variant="info"
          block
          :disabled="this.ui.orders.length < 1"
          @click="$emit('combine-order')"
        >
        Combine Order
        </b-button>
      </b-col>
    </b-row>
    </section>
  </b-card>
</template>

<script>
export default {
  name: 'Order',
  props: {
    ui: { type: Object, default() { return {}; } },
    loading: { type: Boolean, default: false }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pack-and-ship/Order.vue